export default __webpack_public_path__ + "static/media/progress.aa670b92.png";